<template>
  <filter-summary
    icon="item"
    title="商品"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
    >{{ label }}</filter-summary
  >
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品分類の分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    item: {
      type: Object,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    label() {
      if (this.item) {
        return this.item.code
      }
      return ''
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
